import React from 'react';
import { Sheet, Typography } from '@mui/joy';

const Footer = () => {
  return (
    <Sheet
      component="footer"
      variant="soft"
      sx={{
        p:2,
        textAlign: 'center',
      }}
    >
      <Typography level="body-sm">
        © {new Date().getFullYear()} Disk Golf Score Keeper. All rights reserved.
      </Typography>
    </Sheet>
  );
};

export default Footer;
